import { render, staticRenderFns } from "./CommodityFlowAdjustmentDetail.vue?vue&type=template&id=dfd02e3c&scoped=true&"
import script from "./CommodityFlowAdjustmentDetail.vue?vue&type=script&lang=js&"
export * from "./CommodityFlowAdjustmentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd02e3c",
  null
  
)

export default component.exports